(function() {
    'use strict';

    angular
        .module('gwApp')
        .config(localStorageConfig);

    localStorageConfig.$inject = ['$localStorageProvider', '$sessionStorageProvider'];

    function localStorageConfig($localStorageProvider, $sessionStorageProvider) {
        $localStorageProvider.setKeyPrefix('deltazo-main-');
        $sessionStorageProvider.setKeyPrefix('deltazo-main-');
    }
})();
